module.exports = __webpack_public_path__ + "img/meltzerfunding-white-text-only-powered.be285ceb.png";